import { isValidPhoneNumber } from "libphonenumber-js";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { PhoneNumber } from "libphonenumber-js";

document.addEventListener("DOMContentLoaded", () => {
  /* -------------------------------------------------------------------------- */
  /*                                Mobile phone                                */
  /* -------------------------------------------------------------------------- */
  function validateMobilePhoneNumber() {
    setTimeout(() => {
      const phoneInput104 = document.getElementById(
        "nf-field-104"
      ) as HTMLInputElement;
      let typingTimer: NodeJS.Timeout;
      const PhoneInput104Wrap = document.getElementById("nf-field-104-wrap");

      if (phoneInput104) {
        phoneInput104.addEventListener("input", () => {
          phoneInput104.setAttribute("value", phoneInput104.value);
          // console.log(phoneInput104.value);

          clearTimeout(typingTimer);

          typingTimer = setTimeout(() => {
            const phoneNumber = phoneInput104.value;
            if (
              phoneNumber.startsWith("06") ||
              phoneNumber.startsWith("31") ||
              phoneNumber.startsWith("+31")
            ) {
              const isValid = isValidPhoneNumber(phoneNumber, "NL");
              if (isValid) {
                // console.log("Number is valid");
                PhoneInput104Wrap.classList.remove("nf-fail", "nf-error");
                PhoneInput104Wrap.classList.add("nf-pass");
              } else {
                // console.log("Number is invalid");
                PhoneInput104Wrap.classList.add("nf-fail", "nf-error");
                PhoneInput104Wrap.classList.remove("nf-pass");
              }
            } else {
              // console.log("Number does not start with 06, 31, or +31");
              PhoneInput104Wrap.classList.add("nf-fail", "nf-error");
              PhoneInput104Wrap.classList.remove("nf-pass");
            }
          }, 300);
        });
      } else {
        // console.error("Input element with ID 'nf-field-104' not found.");
      }
    }, 300);
  }

  /* -------------------------------------------------------------------------- */
  /*                                 Fixed line                                 */
  /* -------------------------------------------------------------------------- */
  function validateFixedLineNumber() {
    setTimeout(() => {
      const phoneInput105 = document.getElementById(
        "nf-field-105"
      ) as HTMLInputElement;
      let typingTimer: NodeJS.Timeout;
      const PhoneInput105Wrap = document.getElementById("nf-field-105-wrap");

      if (phoneInput105) {
        phoneInput105.addEventListener("input", () => {
          phoneInput105.setAttribute("value", phoneInput105.value);

          clearTimeout(typingTimer);

          typingTimer = setTimeout(() => {
            const phoneNumber = phoneInput105.value;
            const parsedNumber: PhoneNumber | undefined =
              parsePhoneNumberFromString(phoneNumber, "NL");

            if (parsedNumber) {
              console.log("Parsed Number:", parsedNumber.formatInternational());
              console.log("Is Valid:", parsedNumber.isValid());

              if (parsedNumber.isValid()) {
                console.log("Number is valid");
                PhoneInput105Wrap.classList.remove("nf-fail", "nf-error");
                PhoneInput105Wrap.classList.add("nf-pass");
              } else {
                console.log("Number is invalid");
                PhoneInput105Wrap.classList.add("nf-fail", "nf-error");
                PhoneInput105Wrap.classList.remove("nf-pass");
              }
            } else {
              console.log("Failed to parse the phone number.");
              PhoneInput105Wrap.classList.add("nf-fail", "nf-error");
              PhoneInput105Wrap.classList.remove("nf-pass");
            }
          }, 300);
        });
      } else {
        // console.error("Input element with ID 'nf-field-105' not found.");
      }
    }, 300);
  }

  // Add an event listener to validate the phone number on input change
  validateMobilePhoneNumber();
  validateFixedLineNumber();
});
